import { render, staticRenderFns } from "./ItemExecutionDetailsInfo.vue?vue&type=template&id=87cfcb4e&scoped=true"
import script from "./ItemExecutionDetailsInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemExecutionDetailsInfo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ItemExecutionDetailsInfo.vue?vue&type=style&index=0&id=87cfcb4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cfcb4e",
  null
  
)

export default component.exports